import { Sala } from '../models/sala.model';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Curso } from '../models/curso.model';

import { Instrutor } from '../models/instrutor.model';
import { TurmaSimulacao } from '../models/turma-simulacao.model';
import { Totais } from '../models/totais.model';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class CursoService {
  constructor(private http: HttpClient, private base: BaseService) {}

  getCursos(): Observable<Curso[]> {
    return this.http.get<Curso[]>(this.base.endpoints.cursos);
  }

  getSalas(idCurso: number): Observable<Sala[]> {
    return this.http.get<Sala[]>(this.base.endpoints.salas);
  }

  getInstrutores(idCurso: number): Observable<Instrutor[]> {
    return this.http.get<Instrutor[]>(this.base.endpoints.instrutores);
  }

  getTotais(idCurso: number): Observable<Totais> {
    let url = this.base.endpoints.inscricoesTotais;
    url = url.replace(/\{idCurso\}/gi, idCurso.toString());
    return this.http.get<Totais>(url);
  }

  geraSimulacao(idCurso: number): Observable<TurmaSimulacao> {
    let url = this.base.endpoints.cursoSimulacao;
    url = url.replace(/\{idCurso\}/gi, idCurso.toString());
    return this.http.put<TurmaSimulacao>(url, {});
  }
}
